import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../contexts/AppContext";
import { RouteContext } from "../../contexts/RoutesContext";
import { InfoBanner, InfoHeaderIcon } from "../components/Shared/InfoBanner";
import { Colour, UserType } from "../Variables";
import { CentralHeader } from "../components/Shared/CentralHeader";
import { Card } from "../components/Shared/Card";
import { AdditionalInformationForm } from "../components/Home/AdditionalInformationForm";
import { YourApplicationsTable } from "../components/Home/YourApplicationsTable";
import { API_YourApplications, YourApplicationContainerModel } from "../../apis/ApisYourApplications";
import { Link, useSearchParams } from "react-router-dom";
import { PositionDetailsModel } from "../../apis/ApisPositions";
import { API_SupplementaryInformation, SupplementaryInfoModel } from "../../apis/ApisSupplementaryInformation";
import { SupplementaryInfoTable } from "../components/Home/SupplementaryInfoTable";
import { ImageCarousel } from "../components/ImageCarousel";
import { EmailVerification } from "../components/Home/EmailVerification";

export function HomePage() {
    const routeContext = useContext(RouteContext);
    const app = useContext(AppContext);
    const [data, setData] = useState<YourApplicationContainerModel>(null);
    const [siData, setsiData] = useState<SupplementaryInfoModel[]>([]);
    const [queryParameters] = useSearchParams();
    let id = queryParameters.get("id");

    useEffect(() => {
        routeContext.setRoutes([])
    }, []);

    const loadData = async () => {
        var res = await API_YourApplications(app.token);
        setData(res);
        await loadDataSi();
    }

    const loadDataSi = async () => {
        var si = await API_SupplementaryInformation();
        setsiData(si);
    }

    useEffect(() => {
        if (!app.loading) {
            loadData();
        }

    }, [app.loading]);

    let matchedOnID: PositionDetailsModel = null;
    if (!app.loading && app.positions.Positions != null && id != null && id != '')
        matchedOnID = app.positions.Positions.find(x => x.ApplyingForID.toString() == id);

    return (
        <>
            {app.redesign_BannerVer != "-1" && <img src={`/app/StyleBundle/banner?v=${app.redesign_BannerVer}`} className={`d-block w-100 ${app.redesign_BannerOnly ? "mt-3 mb-3" : ""}`} alt="Firm banner image" />}
            {!app.redesign_Carousel && !app.redesign_BannerOnly &&
                <InfoBanner
                    header="Your applications"
                    icon={InfoHeaderIcon.YourApplications}
                    info={null}
                    narrow={app.homeBannerNarrow}
                    subHeader={`${app.firmName} online application system`}
                    theme={app.homeBannerStyle}>
                </InfoBanner>}

            {app.redesign_Carousel && <ImageCarousel />}

            <CentralHeader DarkText={"Your"} SecondaryText={"Data"} />

            <div className="card card-body shadow mt-3 mb-5">
                <p className="pb-0 mb-0 no-highlight">
                    You can request to delete your account at any time. When an account is deleted, your applications are removed and cannot be viewed by you or by {app.firmName}.
                    Your access to this site is also removed. Please contact {app.firmName} directly to request your account is deleted.
                </p>
            </div>

            <EmailVerification />

            <CentralHeader DarkText={"Your"} SecondaryText={"Applications"} />

            {matchedOnID != null &&
                <Card title={"Begin application"} headerTheme={Colour.Secondary} headerClasses={"mb-5"}>
                    <div className="d-flex justify-content-between">
                        <span className="vertical-center">Begin your application for <b>{matchedOnID.CandidateTitle}</b></span>
                        <Link className="btn btn-alt align-self-end" to={`/PositionDetails?id=${matchedOnID.ApplyingForID}`}>Go to position details</Link>
                    </div>
                </Card>}

            <YourApplicationsTable applications={data?.Applications} />

            {app.userLoggedIn && app.baseFeatures.SupplementaryInformationFeature && (app.loggedInUser.UserType == UserType.Agency || app.loggedInUser.UserType == UserType.Candidate) &&
                <>
                    <CentralHeader DarkText={"Additional"} SecondaryText={"Information"} />
                    <Card title={"Add additional information"} headerTheme={Colour.Secondary} headerClasses={"mb-5"}>
                        <AdditionalInformationForm applications={data?.Applications} reload={loadDataSi} />
                    </Card>

                    <SupplementaryInfoTable sppInfos={siData} />
                    <br className="mb-3" />
                </>}
        </>
    );
}